import React, { useState, useEffect } from "react";

//import { Component } from 'react';
import { loremIpsum, fullname, username } from 'react-lorem-ipsum';
import genDesign from './genDesign2.js';
import renderDesign from './renderDesign.js';
import LoaderButton from '../components/LoaderButton';
//import VCNav from '../components/VCNav.js';
import jobTitles from './jobTitles.js';
import titlesString from './dataset-1.js';
//import titlesString from './1-of-each-cluster-num-words-lens.js';
import quotes from './quotes.js';
import slogans from './slogans.js';
import addresses from './addresses.js';

//const txt = "hi hello good morning savitra ji one two three";
//const words = txt.split(" ");
function concatenateNumbers(numbers) {
  return numbers.join(',');
}



function removeExtraWhitespace(str) {
  return str.replace(/\s+/g, ' ').trim();
}


async function renderOne(designsDiv, pred, i) {
  var background={};
  var divEl1 = document.createElement('div');
  divEl1.id='design'+i;

/*
  divEl1.addEventListener("mouseenter", (e) => {
    const index=e.target.id.substr(6,e.currentTarget.id.length-6);
    var btnDiv=document.getElementById('btnDiv'+index);
    btnDiv.className="position-absolute bottom-0 start-50 translate-middle-x";
  });

  divEl1.addEventListener("mouseleave", (e) => {
    const index=e.target.id.substr(6,e.currentTarget.id.length-6);
    var btnDiv=document.getElementById('btnDiv'+index);
    btnDiv.className="d-none";
  });  
*/
  divEl1.className="p-3 col-md-4 col-lg-3 col-sm-6 col-12 border-0 mx-0";

  var divEl2 = document.createElement('div');
  divEl2.className="bg-dark card";
  divEl2.style=""
  divEl2.id='design2'+i;
  divEl1.appendChild(divEl2);
  designsDiv.appendChild(divEl1);

  var z=150;
  var j=24;
  var k=28;
  var tiGoOn=true;
  var stiGoOn=true;
  var auGoOn=true;
  var tempDesign=Object.assign({}, pred);

  while (tiGoOn || stiGoOn || auGoOn) {
    //fontSizeCombo=fontSizeCombos[i];
    while (divEl2.lastChild) {
      divEl2.removeChild(divEl2.lastChild);
    }

    tempDesign.tiFontSize=z;//tiFontSizes[i];//fontSizeCombo.ti;
    tempDesign.stiFontSize=j;//stiFontSizes[j];//fontSizeCombo.sti;
    tempDesign.auFontSize=k;
  
    //console.log(z,j,k);
    //tempDesign.stiY=tempDesign.tiY+((tempDesign.tiNumLines)*1.1*tempDesign.tiFontSize)*1.02+tempDesign.stiHeight*0.05;
    background= await renderDesign(tempDesign, divEl2, i);
    //console.log(background);
    if ( background.tiMaxLineWidth <= background.tiWidth 
     // && background.tiFontSize*1.2*background.tiNumLines <= background.tiHeight
     // && background.tiNumLines <=  background.maxTiNumLines
      //&& background.tiStd <= 3
       || z< 18
    ) {
      tiGoOn=false;
      //console.log(background.tiStd);
    } else {
      z=z-2;
    }
  
    if ( background.stiMaxLineWidth <= background.stiWidth 
    //  && background.stiFontSize*1.2*background.stiNumLines <= background.stiHeight
       //&& background.stiNumLines <=2
       //&& background.stiStd <= 3
  
        || j < 12
    ) {
      stiGoOn=false;
    } else {
      j=j-2;
    } 
  
    if ( background.auMaxLineWidth <= background.auWidth 
    //  && background.auFontSize*1.2*background.auNumLines <= background.auHeight 
      //&& background.auNumLines <=1
      //&& background.auStd <= 3
  
      || k < 18
    ) {
      auGoOn=false;
    } else {
      k=k-2;
    } 


  }


}


function recursiveSplitter(arr, numOfLines) {
  const chunks = [];

  function helper(subArr, linesLeft) {
      if (linesLeft > 1) {
         // const maxSplitIndex = subArr.length - linesLeft; //2
         // let splitIndex = Math.round(Math.random() * (maxSplitIndex))+1; // number between 1 and 2
         var maxSplitIndex = subArr.length-1;// - linesLeft; //2
         var minSplitIndex=1; 
         if (linesLeft ==2 && maxSplitIndex > 2) {
          maxSplitIndex=maxSplitIndex-1;
          minSplitIndex=2;
         }
         let splitIndex = Math.min(Math.max(Math.round(Math.random() * (maxSplitIndex))+1,minSplitIndex),maxSplitIndex); // number between 1 and 2

          const left = subArr.slice(0, splitIndex);
          //console.log(left);
          const right = subArr.slice(splitIndex);
          //console.log(right);

          //helper(left, 1); // always process left first to preserve order
          //var choice = Math.random() > 0.5 ? 1 : 0;
         if (left.length > 1 && right.length > 1) {
             var choice = Math.round(Math.random());
             if (left.length > right.length) choice=1;
              if (choice) {
                  helper(left, linesLeft -1);
                  helper(right, 1);
              } else {
                  helper(left, 1);
                  helper(right, linesLeft - 1);
              }
          } else if (right.length > 1 && left.length == 1){
              helper(left, 1);
              helper(right, linesLeft - 1);
          } else if (left.length > 1 && right.length == 1){
              helper(left, linesLeft -1);
              helper(right, 1);
          } else if (left.length == 1 && right.length == 1){
             helper(left, 1); 
             helper(right, 1);
          }
      } else {
          chunks.push(subArr.join(" "));
      }
  }

  helper(arr, numOfLines);

  return chunks;
}
//var numLines=Math.random()*(words.length-1)+1
//var result=recursiveTitleMakerOrdered(words,numLines);
//console.log(result);

//class Visualizer extends Component {
export default function Visualizer(props) {

  const products=[
    {
      id:"vc",
      orientation: "landscape",
      numElements: 3,
      heading:"Visiting Cards",
      subHeading: "Designs with name, designation, phone and email.",
      tiPlaceholder: "enter name",
      stiPlaceholder: "enter designation",
      auPlaceholder: "enter phone and email",
      cW: 700,
      cH: 400,
      separator: ", "
    },
    {
      id:"bc",
      orientation: "portrait",
      numElements: 3,
      heading:"Book Covers",
      subHeading: "Designs with title, sub title and author(s).",
      tiPlaceholder: "enter title",
      stiPlaceholder: "enter sub title",
      auPlaceholder: "enter author(s)",
      cW: 528,
      cH: 816,
      separator: " "

    },
    {
      id:"posters",
      orientation: "portrait",
      numElements: 2,
      heading:"Posters",
      subHeading: "Designs with title and sub title.",
      tiPlaceholder: "enter poster title",
      //stiPlaceholder: "enter poster sub title",
      auPlaceholder: "enter text",

      cW: 420,//1584,//800,//420,
      cH: 594,//396,//450,//594,
      separator: " "

    },
    {
      id:"signage",
      orientation: "landscape",
      numElements: 2,
      heading:"Signage",
      subHeading: "Designs with brand or company name and slogan.",
      tiPlaceholder: "enter brand or company name",
      stiPlaceholder: "enter slogan",
      cW: 600,
      cH: 400,
      separator: " "

    },
    {
      id:"labels",
      orientation: "landscape",
      numElements: 2,
      heading:"Labels",
      subHeading: "Designs with name and address.",
      tiPlaceholder: "enter brand or company name",
      auPlaceholder: "enter address",
      cW: 789,//263
      cH: 300,//100
      separator: " "

    }      
  ];

  const [product, setProduct]=useState(1);

  const [predictions, setPredictions]=useState([]);
  const [isLoading, setIsLoading]=useState(false);
  const [title, setTitle]=useState('');
  const [subtitle, setSubTitle]=useState('');
  const [au, setAu]=useState('');
  const [tryExample, setTryExample]=useState(true);


function onFieldChange(event) {
  // for a regular input field, read field name and value from the event
  const fieldName = event.target.name;
  const fieldValue = event.target.value;
  if (fieldName==='title') {
    setTitle(fieldValue);
  } else if (fieldName==='subtitle') {
    setSubTitle(fieldValue);
  } else {
    setAu(fieldValue);
  }
  //generateAgain();
  //this.setState({[fieldName]: fieldValue});
}
  function validateForm() {

    const val= (title.length> 0 
	    && subtitle.length>0 
	    //&& au.length>0
      );
	  
      return val;

  }


  async function generateAgain ()  {
    //event.preventDefault();
    setIsLoading(true);
    await generate(false);
    setIsLoading(false);
  }


  async function predict4 (data) {

    try { 

    const res = await fetch('https://vfioslnq17.execute-api.us-east-1.amazonaws.com/dev/split-title', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'text/csv'
      },
      body: JSON.stringify(data)
    });
  
      const body = await res.json();
      return body;

    } catch(e) {console.log(e);}
  }


  async function predict3 (data) {

    const res = await fetch('https://vfioslnq17.execute-api.us-east-1.amazonaws.com/dev/identify-cluster', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'text/csv'
      },
      body: JSON.stringify(data)
    });
  
    const body = await res.json();
    return body;
  }

async function predict2 (data) {

  const res = await fetch('https://vfioslnq17.execute-api.us-east-1.amazonaws.com/dev/vcmagic', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  });

  const body = await res.json();
  return body;
}

useEffect( async () => {
  const pathname=window.location.pathname;
  //console.log(pathname);
  if (pathname === '/vc') {
    setProduct(0);
  } else if (pathname === '/bc') {
    setProduct(1);
  } else if (pathname === '/posters') {
    setProduct(2);
  } else if (pathname === '/signage'){
    setProduct(3);
  } else {
    setProduct(1);
  }

},[]);

useEffect( async () => {

  setIsLoading(true);
  await generate(false);
  setTitle('Tracks of Change');
  setSubTitle('Railways and everyday life in colonial India');
  setAu('Ritika Prasad');
  setIsLoading(false);
},[product]);

async function visualize(predictions, separator) {

var localDataArray=[], designsDiv, background={};

//var preds=predictions;
var preds = predictions;//.slice(0, 24);

designsDiv=document.getElementById('designs1');

while (designsDiv.lastChild) {
  designsDiv.removeChild(designsDiv.lastChild);
}

for (let i = 0; i < preds.length; i++) {
  renderOne(designsDiv, preds[i], i);
}

}

async function generate() {

var localDataArray=[];
const cW=products[product].cW;
const cH=products[product].cH;
const orientation=products[product].orientation;
const numElements=products[product].numElements;
const separator=products[product].separator;

var ti={};//vcD[Math.floor(Math.random() * vcD.length)];
if (title.length > 0 && !tryExample) {
  ti.title=title;
  ti.au=au;
  ti.subtitle=subtitle;
} else {
  //console.log(product);
    if (product==0) {
      ti.title=fullname();
      ti.au='1111122222, '+username()+'@email.com';
      ti.subtitle=jobTitles[Math.floor(Math.random()*jobTitles.length)];
    } else if (product==1) {
      var titles2=JSON.parse(titlesString);
      var titles2=titles2.filter((t) =>   t.title.split(' ').length < 6 && t.title.length > 0 && t.subtitle.length > 0 && t.authors.length > 0);// && t.title.length < 61);
      ti=titles2[Math.floor(Math.random() * titles2.length)];
      ti.au=ti.authors;
    }
    else if (product==2) {
      var titles2=quotes.filter((q) => q.quote.length < 50);
      var title2=titles2[Math.floor(Math.random() * titles2.length)];
      if (title2.author.substring(title2.author.length-1,title2.length)==',') {
        ti.au=title2.author.substring(0,title2.author.length-1);
      } else ti.au=title2.author;

      ti.title=title2.quote;
      ti.subtitle='';
      //console.log(ti);
      //ti.title=loremIpsum({random: true, startWithLoremIpsum: false, p:1, avgSentencesPerParagraph:1, avgWordsPerSentence: Math.random()*2+2})[0].slice(0, -1);
      //ti.subtitle=loremIpsum({random: true, startWithLoremIpsum: false, p:1, avgSentencesPerParagraph:1, avgWordsPerSentence: Math.random()*5+3})[0].slice(0, -1);
      //ti.au=loremIpsum({random: true, startWithLoremIpsum: false, p:1, avgSentencesPerParagraph:1, avgWordsPerSentence: Math.random()*25+10})[0].slice(0, -1);

    }
    else if (product==3) {
      var slogans2=slogans.filter((t) => t.Company.length > 0 && t.Slogan.length > 0);// && t.title.length < 61);
      var title2=slogans2[Math.floor(Math.random() * slogans2.length)];
      ti.title=title2.Company;
      ti.subtitle=title2.Slogan;
      ti.au='';//loremIpsum({random: true, startWithLoremIpsum: false, p:1, avgSentencesPerParagraph:1, avgWordsPerSentence: Math.random()*15+5})[0].slice(0, -1);
    } else {
      var title2=addresses[Math.floor(Math.random() * addresses.length)];

      ti.title=fullname();
      ti.au=title2.address+', '+title2.city+', '+title2.state+', '+title2.zip;
      ti.subtitle='';

    }
}



 // console.log(ti);
//var ti_num_words=(ti.title.split(' ').length-1)/(4);
//var ti_len=(ti.title.length-2)/(56-2);
//var sti_len=(ti.subtitle.length-4)/(159-4);
//var au_len=(ti.au.length-5)/(56-5);
  //var str=ti_num_words+','+ti_len+','+sti_len+','+au_len;
  
  //var response2=await predict3(str);
  //console.log(JSON.parse(response2.body).predictions[0].closest_cluster);
  //console.log(JSON.parse(response2.body).predictions[0].distance_to_cluster);
  //var cluster=JSON.parse(response2.body).predictions[0].closest_cluster;
//var designsTempDiv=document.getElementById('designs2');
/*var design=genDesign(ti,cW,cH,orientation,numElements, cluster);//, tiFontSizeIndex, stiFontSizeIndex, auFontSizeIndex);
design.tiNumLines=0;
design.tiMaxLineWidth=0;
design.auNumLines=0;
design.auMaxLineWidth=0;
design.auNumLines=0;


design.auMaxLineWidth=0;
*/
const words=removeExtraWhitespace(ti.title.toUpperCase()).split(' ');

var lineLenArray=[];
var numLines=2;
for (let i=0; i < 100 ; i++) {
//for (let i = 0; i < (tiFontSizes.length); i++) { 
  //for (let j = 0; j < (stiFontSizes.length); j++) { 
  
    //fontSizeCombo=fontSizeCombos[i];
    //var tempDesign=Object.assign({}, design);

    numLines=Math.min(Math.floor(Math.random()*(words.length)+1),5);
    if (words.length> 1) {numLines=Math.round(Math.random()) > 0.5 ? 5 : 2}

    var tempDesign=genDesign(ti,cW,cH, numLines);
    tempDesign.numLines=numLines;
    if (numLines>2) {
      tempDesign.lines=words;
    } else {
      tempDesign.lines=recursiveSplitter(words,tempDesign.numLines);// Math.random()*(words.length-1)+1);
    }
    tempDesign.line0Len=tempDesign.lines[0] ? tempDesign.lines[0].length : 0;
    tempDesign.line1Len=tempDesign.lines[1] ? tempDesign.lines[1].length : 0;
    tempDesign.line2Len=tempDesign.lines[2] ? tempDesign.lines[2].length : 0;
    tempDesign.line3Len=tempDesign.lines[3] ? tempDesign.lines[3].length : 0;
    tempDesign.line4Len=tempDesign.lines[4] ? tempDesign.lines[4].length : 0;

    //tempDesign.tiFontSize=tiFontSizes[i];//fontSizeCombo.ti;
    //tempDesign.stiFontSize=stiFontSizes[j];//fontSizeCombo.sti;
    //tempDesign.auFontSize=0;//fontSizeCombo.au;

  //console.log(cW,cH,orientation, numElements);

  //var output=await renderDesign(tempDesign, designsTempDiv, i);
	//localDataArray.push(output);



  var str=//tempDesign.sti_au_close+','+tempDesign.ti_sti_close+','+tempDesign.auHeight+','+
     tempDesign.all_apart+','+tempDesign.sti_ti_close+','+tempDesign.ti_sti_close+','+tempDesign.sti_au_close
     +tempDesign.line0Len+','+tempDesign.line1Len+','+tempDesign.line2Len+','+tempDesign.line3Len+','+tempDesign.line4Len
     +','+tempDesign.tiLetterSpacing+','+tempDesign.tiLineSpacingFactor+','+tempDesign.tiWidth
      +','+tempDesign.stiLength+','+tempDesign.auLength;

  lineLenArray.push(str);
  localDataArray.push(tempDesign);

 //}
}

//console.log(JSON.stringify(localDataArray));
//console.log(JSON.stringify(localDataArray.join("\n")));

/*
 while (designsTempDiv.lastChild) {
  designsTempDiv.removeChild(designsTempDiv.lastChild);
}
*/
        var response= await predict4(lineLenArray.join("\n"));


        //var json=JSON.parse(response.body);
        //console.log(response);
        var json=response.body.split(',');

        //console.log(json);
        
  const thresh=0.5;
  for (var e = 0; e < json.length; e++) { 
	  localDataArray[e].predictedLabel=(json[e] > thresh ? 1: 0); 
	  localDataArray[e].score=json[e]; 
  }
  //console.log(localDataArray);
  localDataArray.sort((a,b) => b.score - a.score); // b - a for reverse sort
  var filtered = localDataArray.filter(o=> o.predictedLabel ==1);// && o.tiMaxLineWidth <= o.tiWidth  && o.tiFontSize*o.tiNumLines <= o.tiHeight);
  const grouped = groupBy(filtered, pred => pred.ti_sti_close+','+pred.all_apart+','+pred.sti_au_close+','+pred.sti_ti_close+','+pred.numLines);


	let selected=[];
  //console.log(grouped);
grouped.forEach((_value, key) => {
          const oneGroup=_value;
	  selected.push(oneGroup[0]);//Math.floor(Math.random()*oneGroup.length)]);
	})
  
  
  //selected=filtered;
//console.log(selected);
//filtered=filtered.slice(0,12);
    selected=selected.slice(0,12);
	  setPredictions(selected);//filtered);	
    visualize(selected, separator);//filtered, separator);//fontCombo);

//console.log(localDataArray);


//visualize(filtered, separator);//fontCombo);

}


function groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
         const key = keyGetter(item);
         const collection = map.get(key);
         if (!collection) {
             map.set(key, [item]);
         } else {
             collection.push(item);
         }
    });
    return map;
}

function downloadCanvasAsImage(e,type) {

  const index=e.currentTarget.id.substr(6,e.currentTarget.id.length-6);
  let canvasImage = document.getElementById('designCanvas'+index).toDataURL(type);
    
    // this can be used to download any image from webpage to local disk
    let xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.onload = function () {
        let a = document.createElement('a');
        a.href = window.URL.createObjectURL(xhr.response);
        a.download = 'yourdesign';
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();
      };
      xhr.open('GET', canvasImage); // This is to download the canvas Image
      xhr.send();
}


return (

  <div className="1Login bg-dark text-white">
     <nav className="navbar navbar-expand-lg navbar-light bg-light border-bottom border-dark">
        <div className="container-fluid">
          <a className="navbar-brand h1 mb-0" href="/">{process.env.REACT_APP_PRODUCT === 'kavad' ? 'LineCap' : 'LineCap' }</a>
   {/*} <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
      <ul className="navbar-nav">
      <li className="nav-item">
          <a className="nav-link" href="#" onClick={(e) => setProduct(1)}>Book Covers</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#" onClick={(e) => setProduct(0)}>Visiting Cards</a>
        </li>

        <li className="nav-item">
          <a className="nav-link" href="#" onClick={(e) => setProduct(2)}>Posters</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#" onClick={(e) => setProduct(3)}>Signage</a>
        </li>      
        <li className="nav-item">
          <a className="nav-link" href="#" onClick={(e) => setProduct(4)}>Labels</a>
        </li> 
      </ul>
    </div>*/}
        </div>
      </nav>
    <div className="offset-md-0 col-md-12 col-sm-12 p-lg-5 p-md-3 p-sm-1">
 	  <div className="card-body my-3 col-12 col-lg-6 1col-offset-0 1container offset-lg-0">
      <h1 className="h1 1card-title">{products[product].heading}</h1>
      <p className="1card-subtitle text-white">{products[product].subHeading}</p>
      
      <div className="1card-body my-4">
        <ul className="nav nav-tabs bg-dark">
          <li className="nav-item">
            <a className={tryExample ? "nav-link active" : "nav-link"} aria-current="page" href="#" onClick={(e) => setTryExample(true)}>Try an Example</a>
          </li>
          <li className="nav-item">
            <a className={!tryExample ? "nav-link active" : "nav-link"} href="#" onClick={(e) => setTryExample(false)}>Try your own</a>
          </li>
        </ul>


        {!tryExample && <div className="col-lg-8 col-md-10 col-sm-12">
        {products[product].tiPlaceholder && <div className="card-body">
            <input className="form-control"
              autoFocus
	            required
              value={title}
              type="text"
              placeholder={products[product].tiPlaceholder}
              name="title"
	            onChange={onFieldChange}
              onBlur={generateAgain}
            />
	        </div>}
          {products[product].stiPlaceholder && <div className="card-body">
            <input className="form-control"
              value={subtitle}
              type="text"
	            required
              placeholder={products[product].stiPlaceholder}
              name="subtitle"
              onChange={onFieldChange}
              onBlur={generateAgain}

            />
          </div>}
          {products[product].auPlaceholder && <div className="card-body">
            <input className="form-control"
              value={au}
              type="text"
	            required
              placeholder={products[product].auPlaceholder}
              name="au"
              onChange={onFieldChange}
              onBlur={generateAgain}

             />
           </div>}
        </div>}
        
        <LoaderButton disabled={!validateForm() && !tryExample} isLoading={isLoading} className="mt-3 btn btn-outline-light 1text-white" onClick={generateAgain}>
          Generate designs
        </LoaderButton>

      </div>
    </div>

    {isLoading ? <div className="card-body p-3"><p className="1text-center card-text">loading...</p></div> : 
	    predictions.length < 1 ? <div className="p-3 col-4 offset-4 card-body"><p className="text-center card-text">Sorry, we don't have designs for this text!</p></div> : ''}


    <div className="col-12 d-flex d-none justify-content-left flex-wrap" id="designs2" style={{display: "none"}}></div>
     <div className="col-12 d-flex justify-content-left flex-wrap bg-dark text-white p-0" id="designs1"></div>


  </div>
  <footer className="m-3 py-3 text-muted border-top1 bg-dark text-white">
    {process.env.REACT_APP_PRODUCT === 'kavad' ? <p> &copy; LineCap 2024</p> : <p> &copy; LineCap 2024</p>}
  </footer>
</div>


);}
